// extracted by mini-css-extract-plugin
export default {"areaTooltip":"_1WmQG___ListingMediaPhotoSection-module__areaTooltip","areaOverlay":"_1C3_E___ListingMediaPhotoSection-module__areaOverlay"};